// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { FormGroup, InputGroup, Intent } from '@blueprintjs/core';
import classNames from 'classnames';

import { CellType } from '@/constants';
import { CLASSES } from '@/constants/classes';

const PercentFieldCell = ({
  cell: { value: initialValue },
  row: { index },
  column: { id },
  payload: { errors, updateData },
  disabled,
}) => {
  const [value, setValue] = useState(
    initialValue !== '' && initialValue !== undefined && initialValue !== null
      ? String(initialValue)
      : '',
  );
  const [error, setError] = useState(null);

  useEffect(() => {
    setValue(
      initialValue !== '' && initialValue !== undefined && initialValue !== null
        ? String(initialValue)
        : '',
    );
  }, [initialValue]);

  const handleChange = (e) => {
    const raw = e.target.value;
    // Allow digits and at most one decimal point
    if (raw !== '' && !/^\d*\.?\d*$/.test(raw)) {
      return;
    }
    setValue(raw);

    if (raw === '') {
      setError(null);
      return;
    }

    const num = parseFloat(raw);
    if (Number.isNaN(num) || num < 0 || num > 100) {
      setError('Please enter a valid discount percentage between 0 and 100.');
    } else {
      setError(null);
    }
  };

  const handleBlur = () => {
    if (value === '' || value === undefined || value === null) {
      setError(null);
      updateData(index, id, '');
      return;
    }

    const num = parseFloat(value);
    if (Number.isNaN(num) || num < 0 || num > 100) {
      setError('Please enter a valid discount percentage between 0 and 100.');
      return;
    }

    setError(null);
    setValue(String(num));
    updateData(index, id, num);
  };

  const fieldError = error || errors?.[index]?.[id];

  return (
    <FormGroup
      intent={fieldError ? Intent.DANGER : null}
      className={classNames(CLASSES.FILL)}
      helperText={
        fieldError ? (
          <span style={{ color: '#cd4246', fontSize: 11 }}>{fieldError}</span>
        ) : null
      }
    >
      <InputGroup
        type="text"
        inputMode="decimal"
        value={value}
        disabled={disabled}
        onChange={handleChange}
        onBlur={handleBlur}
        intent={fieldError ? Intent.DANGER : Intent.NONE}
        rightElement={
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              height: '100%',
              paddingRight: 6,
              color: '#5c7080',
              fontSize: 12,
              fontWeight: 500,
              userSelect: 'none',
              pointerEvents: 'none',
            }}
          >
            %
          </span>
        }
      />
    </FormGroup>
  );
};

PercentFieldCell.cellType = CellType.Field;

export default PercentFieldCell;
